<template>
  <template v-if="!isAgwRoute">
    <div class="site-shell">
      <!-- AGW 외에는 헤더 + nav + 컨텐츠 -->
      <header class="nav-header">
        <nav class="nav-bar page-shell">
          <ul class="nav-list">
            <li>
              <RouterLink
                to="/"
                class="menu-link"
                exact-active-class="active-link"
                >Home</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/admin"
                class="menu-link"
                exact-active-class="active-link"
                >관리자</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/member"
                class="menu-link"
                exact-active-class="active-link"
                >식당</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/customer"
                class="menu-link"
                exact-active-class="active-link"
                >거래처</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/user"
                class="menu-link"
                exact-active-class="active-link"
                >사용자</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/agw"
                class="menu-link"
                exact-active-class="active-link"
                >AGW</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/inet"
                class="menu-link"
                exact-active-class="active-link"
                >시설정보</RouterLink
              >
            </li>
            <li>
              <RouterLink
                to="/erp"
                class="menu-link"
                exact-active-class="active-link"
                >ERP</RouterLink
              >
            </li>
          </ul>
        </nav>
      </header>

      <main class="main-content page-shell">
        <RouterView />
      </main>
    </div>
  </template>

  <template v-else>
    <RouterView />
  </template>

  <footer class="footer page-shell">
    <b>Powered By 성덕컴퓨터</b>
    <div>
      📧
      <a href="mailto:zanmoo@gmail.com" class="footer-link">zanmoo@gmail.com</a>
    </div>

    <div class="footer-contact">
      📞 <a href="tel:01034005253" class="footer-link">010-3400-5253</a>
    </div>
  </footer>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { buildAddressPopupUrl, buildApiUrl, getFrontendOrigin } from "@/api";

// 현재 경로 확인
const route = useRoute();
const isAgwRoute = computed(
  () =>
    route.path.startsWith("/agw") ||
    route.path.startsWith("/smile") ||
    route.path.startsWith("/inet") ||
    route.path.startsWith("/sungho")
);
const hidemenu = 1;
// 폼 데이터
const corpname = ref("");
const address = ref("");
const president = ref("");
const corpnumber = ref("");
const phone = ref("");
const email = ref("");
const amount = ref("");
const monthamount = ref("");
const notes = ref("");
const zipNo = ref("");

// 업체 등록
async function registerCompany() {
  try {
    const response = await fetch(buildApiUrl("register"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        corpname: corpname.value,
        address: address.value,
        president: president.value,
        corpnumber: corpnumber.value,
        phone: phone.value,
        email: email.value,
        amount: amount.value,
        monthamount: monthamount.value,
        notes: notes.value,
      }),
    });

    if (response.ok) {
      alert("업체가 성공적으로 등록되었습니다.");
      clearForm();
    } else {
      alert("등록 중 오류가 발생했습니다.");
    }
  } catch (error) {
    console.error(error);
    alert("서버 오류");
  }
}

function clearForm() {
  corpname.value = "";
  address.value = "";
  president.value = "";
  corpnumber.value = "";
  phone.value = "";
  email.value = "";
  amount.value = "";
  monthamount.value = "";
  notes.value = "";
  zipNo.value = "";
}

// 주소 팝업 열기
function openAddressPopup() {
  const popup = window.open(
    buildAddressPopupUrl("U01TX0FVVEgyMDI1MDIxMTIxNTk0NzExNTQ2MzM"),
    "pop",
    "width=570,height=420,scrollbars=yes,resizable=yes"
  );

  window.addEventListener("message", handlePopupMessage, false);
}

function handlePopupMessage(event) {
  if (event.origin !== getFrontendOrigin()) {
    console.log("Ignored message from:", event.origin);
    return;
  }

  try {
    const data = JSON.parse(event.data);
    if (data && data.roadFullAddr) {
      address.value = data.roadFullAddr;
      zipNo.value = data.zipNo;
    }
  } catch (err) {
    console.error("JSON parse failed:", err);
  }

  window.removeEventListener("message", handlePopupMessage, false);
}

// 주소 리스너 정리도 가능
onBeforeUnmount(() => {
  window.removeEventListener("message", handlePopupMessage);
});
</script>

<style>
.site-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.nav-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid var(--border);
  backdrop-filter: blur(14px);
}

.nav-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
}

.nav-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 10px;
  margin: 0;
  background: var(--surface);
  border-radius: 999px;
  border: 1px solid var(--border);
  box-shadow: 0 10px 28px rgba(31, 42, 36, 0.08);
}

.menu-link {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.menu-link:hover {
  background: rgba(27, 127, 108, 0.1);
  color: var(--accent-strong);
  transform: translateY(-1px);
}

.active-link {
  background: var(--accent);
  color: #ffffff;
}

.main-content {
  flex: 1;
  margin: 32px auto 0;
  padding: 32px;
  border-radius: var(--radius-lg);
  background: var(--surface-soft);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  animation: fadeUp 0.6s ease;
}

.footer {
  margin: 40px auto 60px;
  padding: 20px 28px;
  border-radius: var(--radius-md);
  background: linear-gradient(120deg, #f7efe6, #ffffff);
  border: 1px solid var(--border);
  color: var(--muted);
  font-style: italic;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.footer b {
  color: var(--accent-strong);
  font-size: 16px;
  font-style: normal;
}

.footer-contact {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.footer-link {
  color: var(--accent-warm);
  text-decoration: none;
  font-weight: 600;
}

.footer-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .nav-bar {
    padding: 12px 16px;
  }

  .nav-list {
    justify-content: center;
  }

  .main-content {
    margin: 24px 16px 0;
    padding: 24px;
  }

  .footer {
    margin: 32px 16px 48px;
  }
}
</style>
